import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import { openCloseModalEncuestaTrabajadores, editarPlanMovilidadEncuesta, onAlertaPlanMovilidad } from "../../actions";
import DateField from "../../../../Shared/fields/DateField";
import NumberField from "../../../../Shared/fields/NumberField";
import { dataLayerTag } from "../../functions";

class ModalCrearEncuesta extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      cantidadHombresCentro: 0,
      cantidadMujeresCentro: 0,
      fechaCierreEncuestaTrabajador: null,
      isLoad: false,
    };
  }

  componentDidUpdate = () => {
    if (!this.state.isLoad && this.props.isOpenEncuestaModal) {
      this.setThisState();
    } else if ((this.state.isLoad && !this.props.isOpenEncuestaModal)) {
      this.unSetThisState();
    }
  }

  setThisState = () => {
    this.setState({
      cantidadHombresCentro: (this.props.cantidadHombresCentro ? this.props.cantidadHombresCentro : 0),
      cantidadMujeresCentro: (this.props.cantidadMujeresCentro ? this.props.cantidadMujeresCentro : 0),
      fechaCierreEncuestaTrabajador: (this.props.fechaCierreEncuestaTrabajador ? this.props.fechaCierreEncuestaTrabajador : null),
      isLoad: true,
    });
  }

  unSetThisState = () => {
    this.setState({
      cantidadHombresCentro: null,
      cantidadMujeresCentro: null,
      fechaCierreEncuestaTrabajador: null,
      isLoad: false,
    });
  }


  onCheckValues = () => {
    if (this.state.cantidadHombresCentro + this.state.cantidadMujeresCentro < 1) {
      this.props.dispatch(onAlertaPlanMovilidad("error", "Debe tener al menos 1 trabajador en el centro."));
    } else if (!this.state.fechaCierreEncuestaTrabajador) {
      this.props.dispatch(onAlertaPlanMovilidad("error", "Debe completar la fecha de cierre de la encuesta de trabajador."));
    } else if (
      this.props.cantidadHombresCentro === this.state.cantidadHombresCentro &&
      this.props.cantidadMujeresCentro === this.state.cantidadMujeresCentro &&
      this.props.fechaCierreEncuestaTrabajador === this.state.fechaCierreEncuestaTrabajador
    ) {
      this.props.dispatch(onAlertaPlanMovilidad("warning", "No se hizo ninguna modificación."));
      this.handleClose();
    } else {
      this.onSuccessEncuesta();
      this.handleClose();
    }
  }

  handleChange = (e) => {
    switch (e.element.id) {
      case "fechaCierreEncuestaTrabajador":
        this.setState({ fechaCierreEncuestaTrabajador: (new Date(e.value)) });
        break;
      case "cantidadHombresCentro":
        this.setState({ cantidadHombresCentro: e.value });
        break;
      case "cantidadMujeresCentro":
        this.setState({ cantidadMujeresCentro: e.value });
        break;
      default:
        console.log(`ERROR! ${e}`);
        break;
    }
  }

  handleClose = () => {
    this.props.dispatch(openCloseModalEncuestaTrabajadores(false, {}));
  }

  onSuccessEncuesta = () => {
    this.props.dispatch(editarPlanMovilidadEncuesta(
      this.props.idplanMovilidad,
      true,
      this.state.cantidadHombresCentro,
      this.state.cantidadMujeresCentro,
      this.state.fechaCierreEncuestaTrabajador
    ));
    this.handleClose();
    // gtd -> habilito encuesta de trabajador
    dataLayerTag({
      'event': 'etapa_2_configuración_encuesta_trabajadores',
      'etapa': '2'
    });
  }

  render() {
    return (
      <Popup
        title="Configuración encuesta de trabajadores"
        visible={this.props.isOpenEncuestaModal}
        dragEnabled={false}
        showCloseButton
        onHiding={this.handleClose}
        height={400}
        width={500}
        contentComponent={() => (
          <div>
            <div style={{ position: "absolute", left: 20, right: 20 }}>
              <DateField
                styleRoot={{ marginTop: 0 }}
                label="Fecha Cierre Encuesta Trabajador"
                id="fechaCierreEncuestaTrabajador"
                onChange={this.handleChange}
                type="date"
                min={new Date()}
                max={new Date().setFullYear(3000)}
                value={this.state.fechaCierreEncuestaTrabajador}
              />
              <NumberField
                inputAttr={{ maxLength: 4 }}
                max={1000}
                min={0}
                label="Cantidad de Hombres del Centro de Trabajo"
                id="cantidadHombresCentro"
                showSpinButtons
                onChange={this.handleChange}
                value={this.state.cantidadHombresCentro}
              />
              <NumberField
                inputAttr={{ maxLength: 4 }}
                max={1000}
                min={0}
                label="Cantidad de Mujeres del Centro de Trabajo"
                id="cantidadMujeresCentro"
                showSpinButtons
                onChange={this.handleChange}
                value={this.state.cantidadMujeresCentro}
              />
            </div>
            <div className="button-row">
              <div><Button text="Cancelar" onClick={this.handleClose} /></div>
              <div><Button text="Guardar" type="success" onClick={this.onCheckValues} /></div>
            </div>
          </div>
        )}
      />
    );
  }
}


const mapStateToProps = (state) => ({
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  // habilitarTokenEncuesta: state.planMovilidad.habilitarTokenEncuesta,

  cantidadHombresCentro: state.planMovilidad.cantidadHombresCentro,
  cantidadMujeresCentro: state.planMovilidad.cantidadMujeresCentro,
  fechaCierreEncuestaTrabajador: state.planMovilidad.fechaCierreEncuestaTrabajador,
  isOpenEncuestaModal: state.planMovilidad.isOpenEncuestaModal,
  // dataEncuestaModal: state.planMovilidad.dataEncuestaModal,

});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalCrearEncuesta);
